import api from 'connections/api';
import routes_api from 'connections/routes_api';

// ###### BUDGET PLANS
export const getBudgetPlans = async (params = {}) => {
  return api.get(routes_api.finance_budget_plans, { params });
};

export const createBudgetPlan = async (data) => {
  return api.post(routes_api.finance_budget_plans, data);
};

export const updateBudgetPlan = async (id, data) => {
  return api.patch(`${routes_api.finance_budget_plans}${id}/`, data);
};

export const deleteBudgetPlan = async (id) => {
  return api.delete(`${routes_api.finance_budget_plans}${id}/`);
};

// Get or create a BudgetPlan for a given date (YYYY-MM-DD).
// Returns the plan (existing or newly created).
export const getOrCreateBudgetPlan = async (date) => {
  return api.post(`${routes_api.finance_budget_plans}get-or-create/`, { date });
};

// ###### BUDGET PLAN ITEMS
export const getBudgetPlanItems = async (params = {}) => {
  return api.get(routes_api.finance_budget_plan_items, { params });
};

export const createBudgetPlanItem = async (data) => {
  return api.post(routes_api.finance_budget_plan_items, data);
};

export const updateBudgetPlanItem = async (id, data) => {
  return api.patch(`${routes_api.finance_budget_plan_items}${id}/`, data);
};

export const deleteBudgetPlanItem = async (id) => {
  return api.delete(`${routes_api.finance_budget_plan_items}${id}/`);
};

// Duplicate a BudgetPlan (and all its items) to a target month.
// Fails with 409 if the target month already has a plan.
export const duplicateBudgetPlan = async (planId, targetDate) => {
  return api.post(`${routes_api.finance_budget_plans}${planId}/duplicate/`, { target_date: targetDate });
};

// ###### BUDGET BOARD
export const getBudgetBoard = async (params = {}) => {
  return api.get(routes_api.finance_budget_board, { params });
};
